import { AppUtils } from '../../../../../shared/utils/index';
import { Application } from '../../../../../shared/models/view/Application';
import { AppFormModel } from './AppFormModel';

/**
 * The application model that holds the data for the whole application.
 */
export class AppApplicationModel extends Application {
	private formModel: AppFormModel;
	private vorgangsnummer: string;
	constructor(
		register?: string,
		formModel: AppFormModel = new AppFormModel()
	) {
		super(register);

		this.formModel = formModel;
	}

	set FormModel(value: AppFormModel) {
		this.formModel = value;
	}

	get FormModel(): AppFormModel {
		return this.formModel;
	}


	get Vorgangsnummer(): string {
		return this.vorgangsnummer;
	}

	set Vorgangsnummer(value: string) {
		this.vorgangsnummer = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): AppApplicationModel {
		return AppUtils.Helper.createFromMap(dataObject, AppApplicationModel, (key: string, value: any) => {
			switch (key) { //NOSONAR
				case 'formModel':
					return AppFormModel.createFromObject(value);
				default:
					return value;
			}
		});
	}
}
